import { render, staticRenderFns } from "./Jna.vue?vue&type=template&id=10d0be88&"
import script from "./Jna.vue?vue&type=script&lang=js&"
export * from "./Jna.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports